import styled from '@emotion/styled';
import { Variables, CollapsibleContainer } from '../../base';
export const ClaimsContainerWrapper = styled.div`
    & > div {

        justify-content: center;
        min-height: 40px;
        background-color: ${Variables.ThemeLight.Background3};
        padding: 15px;
    }
`;
export const ClaimsCollapsibleContainer = styled(CollapsibleContainer)`
    border-radius: unset !important;
    border: none !important;
    margin: 0;
`;

export const TabContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
`;

export const SectionHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
`;

export const SectionTitle = styled.h4`
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n85};
    line-height: 1;
`;

export const InlineSummary = styled.span`
    margin-left: 4px;
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.Colors.b300};
    line-height: 1;
`;

export const SearchSection = styled.div``;

export const SummarySection = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
    padding: 13px;
    background-color: ${Variables.Colors.white};
    border-radius: ${Variables.Rounded.medium};
`;

export const SummaryLabel = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
`;

export const SummaryLabelTitle = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.TextMedium};
    text-align: center;
`;

export const SummaryLabelValue = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.regular};
    color: ${Variables.ThemeLight.TextMedium};
`;

export const LoadingMessage = styled.div`
    text-align: center;
    padding: 32px;
    color: ${Variables.Colors.n70};
    font-size: 14px;
`;

export const EmptyMessage = styled.div`
    text-align: center;
    padding: 32px;
    color: ${Variables.Colors.n50};
    font-size: 14px;
`;

export const Table = styled.table`
    width: 100%;
    background-color: ${Variables.Colors.white};
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 4px;
    border-spacing: 0px;

    thead th {
        border-bottom: 1px solid ${Variables.ThemeLight.Border2};
    }
    tbody tr:not(:last-child) td {
        border-bottom: 1px solid ${Variables.ThemeLight.Border2};
    }

    thead tr:first-of-type th:first-of-type {
        border-top-left-radius: 4px;
    }
    thead tr:first-of-type th:last-of-type {
        border-top-right-radius: 4px;
    }
    tbody tr:last-child td:first-of-type {
        border-bottom-left-radius: 4px;
    }
    tbody tr:last-child td:last-of-type {
        border-bottom-right-radius: 4px;
    }
`;

export const TableHead = styled.thead`
    background-color: ${Variables.ThemeLight.Background1};
`;

export const TableBody = styled.tbody`
    background-color: ${Variables.ThemeLight.Background2};
    overflow: visible;
`;

export const TableRow = styled.tr`
    &:not(:last-child) {
    }
    &:hover {
        background-color: ${Variables.Colors.n5};

        /* Show action buttons on row hover */
        .actions-container {
            opacity: 1;
        }
    }
`;

export const TableHeader = styled.th`
    padding: 12px;
    text-align: left;
    font-size: 14px;
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.TextMedium};
    letter-spacing: 0.5px;

    &.align-right {
        text-align: right;
        padding-right: 12px;
    }
`;

export const TableHeaderContent = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

export const TableCell = styled.td`
    padding: 12px;
    font-size: 14px;
    color: ${Variables.ThemeLight.TextMedium};
    font-weight: ${Variables.FontWeight.regular};

    &.actions {
        text-align: center;
        padding: 13.75px 12px;
        overflow: visible;
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s ease;
`;

export const ActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: none;
    background-color: transparent;
    color: ${Variables.Colors.n70};
    cursor: pointer;
    border-radius: ${Variables.Rounded.small};
    transition: all 0.2s ease;

    &:hover {
        background-color: ${Variables.Colors.n15_16};
        color: ${Variables.Colors.b300};
    }

    &:active {
        background-color: ${Variables.Colors.n15_24};
    }
`;

export const MenuContainer = styled.div`
    position: relative;
    display: inline-block;
`;

export const MenuButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #94a3b8;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        color: #475569;
    }
`;

export const DropdownMenu = styled.div`
    position: absolute;
    right: 0;
    bottom: calc(100% + 4px);
    min-width: 180px;
    background-color: ${Variables.Colors.white};
    border: 1px solid #e2e8f0;
    border-radius: ${Variables.Rounded.medium};
    box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    z-index: 1000;
    overflow: hidden;
`;

export const MenuItem = styled.button`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 10px 16px;
    border: none;
    background-color: transparent;
    color: #1e293b;
    font-size: 14px;
    font-weight: ${Variables.FontWeight.medium};
    text-align: left;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #f8fafc;
    }

    &:not(:last-child) {
        border-bottom: 1px solid #f1f5f9;
    }

    svg {
        color: #64748b;
        flex-shrink: 0;
    }
`;

export const TableFooter = styled.div`
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const PaginationInfo = styled.div`
    font-size: 13px;
    color: ${Variables.Colors.n70};
`;

export const PaginationControls = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

export const PageInfo = styled.span`
    font-size: 14px;
    color: ${Variables.Colors.n85};
    font-weight: 500;
`;

export const CopyAllButton = styled.button`
    align-self: flex-end;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    color: ${Variables.Colors.b300};
    background-color: transparent;
    border: 1px solid ${Variables.Colors.b300};
    border-radius: ${Variables.Rounded.small};
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 32px;
    min-height: 32px;

    &:hover {
        background-color: ${Variables.Colors.b300_l96};
    }

    &:active {
        background-color: ${Variables.Colors.b300_l90};
    }
`;

export const BulkSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const BulkLabel = styled.label`
    font-size: 14px;
    font-weight: 500;
    color: ${Variables.Colors.n85};
`;

export const BulkError = styled.div`
    color: ${Variables.Colors.r50};
    font-size: 14px;
    margin-top: 8px;
`;

export const BulkButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
`;
